import * as yup from "yup";
import I18n from "@/i18n-js/instance";

export const CREATE_CONVERSATION_SCHEMA = yup.object().shape({
  text: yup
    .string()
    .required(I18n.t("support_widget.send_message_form.error.text")),
});
